// 실제 이벤트 핸들러
export function phoneNumberKeyup(column_name, value) {
    if (column_name === "company_manager_phone") {
        return formatPhoneNumber(value);
    }
    return value;
}
/**
 * @description 전화번호에 하이픈을 자동으로 삽입하여 포맷팅합니다.
 */
export function formatPhoneNumber(value) {
    if (!value || value.length < 3)
        return value;
    const digits = value.replace(/[^0-9]/g, "");
    // 02 지역번호 처리
    if (digits.startsWith("02")) {
        return formatSeoulNumber(digits);
    }
    // 일반 번호 처리 (010, 031 등)
    return formatGeneralNumber(digits);
}
function formatSeoulNumber(value) {
    let res = "";
    if (value.length <= 5) {
        //02-123-5678
        res = value.substring(0, 2) + "-" + value.substring(2, 5);
    }
    else if (value.length > 5 && value.length <= 9) {
        //02-123-5678
        res =
            value.substring(0, 2) +
                "-" +
                value.substring(2, 5) +
                "-" +
                value.substring(5);
    }
    else if (value.length > 9) {
        //02-1234-5678
        res =
            value.substring(0, 2) +
                "-" +
                value.substring(2, 6) +
                "-" +
                value.substring(6);
    }
    return res;
}
function formatGeneralNumber(value) {
    let res = "";
    if (value.length < 8) {
        res = value;
    }
    else if (value.length == 8) {
        res = value.substring(0, 4) + "-" + value.substring(4);
    }
    else if (value.length == 9) {
        res =
            value.substring(0, 3) +
                "-" +
                value.substring(3, 6) +
                "-" +
                value.substring(6);
    }
    else if (value.length == 10) {
        res =
            value.substring(0, 3) +
                "-" +
                value.substring(3, 6) +
                "-" +
                value.substring(6);
    }
    else if (value.length > 10) {
        //010-1234-5678
        res =
            value.substring(0, 3) +
                "-" +
                value.substring(3, 7) +
                "-" +
                value.substring(7);
    }
    return res;
}
